import { api } from './index';

const BASE_PATH = '/api/internal/internal_analytics_events';

export type AnalyticsCategory = 'shifts' | 'caregivers' | 'patients' | 'charges' | 'payments';

export interface AnalyticsEventPayload {
  category: AnalyticsCategory;
  eventType: string;
  properties?: Record<string, unknown>;
  subjectType?: 'Shift' | 'Patient' | 'Caregiver';
  subjectId?: number;
}

export const internalAnalyticsApi = {
  track(payload: AnalyticsEventPayload): void {
    api({
      method: 'post',
      url: BASE_PATH,
      data: { event: payload },
    });
  },
};
